// extracted by mini-css-extract-plugin
module.exports = {"warpper":"index_warpper__TA0ig","margin_top":"index_margin_top__HrZdz"};